import { setResults } from "./searchSlice";
import searchClient from "../services/apollo/apolloClient/searchClient";
import { GET_PLACES } from "../services/apollo/queries/searchQueries";

export const fetchResults = (queryKeyword, coordinates) => async (dispatch, getState) => {
  console.log("Fetching results for:", { queryKeyword, coordinates });
  const cacheKey = `${queryKeyword}-${coordinates?.[0]}-${coordinates?.[1]}`;
  const cachedResults = getState().search.results[cacheKey];

  if (cachedResults) {
    return cachedResults;
  }

  
  try {
    const [longitude, latitude] = coordinates;

    const response = await searchClient.query({
      query: GET_PLACES,
      variables: { latitude, longitude, keyword: queryKeyword, aiRerank: true },
    });

    if (response.errors) {
      console.error("GraphQL Errors:", response.errors);
      throw new Error("Failed to fetch results.");
    }

    const places = response.data.getPlaces || [];

    dispatch(setResults({ cacheKey, data: places }));

    return places;
  } catch (error) {
    console.error("Error during fetch:", error);
    throw error;
  }
};